var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationPhotos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationPhotos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.928,3.6 C12.2991354,3.6 12.6,3.90086465 12.6,4.272 L12.6,10.992 C12.6,11.548703 12.148703,12 11.592,12 L4.872,12 C4.50086465,12 4.2,11.6991354 4.2,11.328 L11.592,11.328 C11.7775677,11.328 11.928,11.1775677 11.928,10.992 L11.928,3.6 Z M11.4,9.83076923 C11.4,10.3660606 10.9660606,10.8 10.4307692,10.8 L3.96923077,10.8 C3.4339394,10.8 3,10.3660606 3,9.83076923 L3,3.36923077 C3,2.8339394 3.4339394,2.4 3.96923077,2.4 L10.4307692,2.4 C10.9660606,2.4 11.4,2.8339394 11.4,3.36923077 L11.4,9.83076923 Z M8.90907692,6.37061538 C8.97016965,6.30987804 9.05298946,6.27605514 9.13913456,6.27666179 C9.22527966,6.27726845 9.3076149,6.31225442 9.36784615,6.37384615 L10.7538462,7.75984615 L10.7538462,3.36923077 C10.7538462,3.19080031 10.6091997,3.04615385 10.4307692,3.04615385 L3.96923077,3.04615385 C3.79080031,3.04615385 3.64615385,3.19080031 3.64615385,3.36923077 L3.64615385,8.406 L5.68153846,6.37384615 C5.80755056,6.24858161 6.01106482,6.24858161 6.13707692,6.37384615 L7.52307692,7.75984615 L8.90907692,6.37061538 Z M7.5,3.6 C7.73869484,3.6 7.96761336,3.69482116 8.1363961,3.8636039 C8.30517884,4.03238664 8.4,4.26130516 8.4,4.5 C8.4,4.99705627 7.99705627,5.4 7.5,5.4 C7.00294373,5.4 6.6,4.99705627 6.6,4.5 C6.6,4.00294373 7.00294373,3.6 7.5,3.6 Z M7.5,4.8 C7.66568542,4.8 7.8,4.66568542 7.8,4.5 C7.8,4.33431458 7.66568542,4.2 7.5,4.2 C7.33431458,4.2 7.2,4.33431458 7.2,4.5 C7.2,4.66568542 7.33431458,4.8 7.5,4.8 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-44.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotificationPhotos",
    transform: "translate(44.000000, 280.997481)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    fill: "#11AB96",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationPhotos);
export default __webpack_public_path__ + "static/media/icNotificationPhotos.8ea57c94540759b37155f097e44ccc0f.svg";
export { ForwardRef as ReactComponent };